import React from 'react';
import {I18n, Translate} from 'react-redux-i18n';
import PropTypes from 'prop-types';
import groupBy from 'lodash.groupby';
import {Accordion} from '@material-ui/core';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import {Icon} from 'front-onceforall-core';
import {sortRecentFirstWithBestEfforts} from 'front-onceforall-core/dist/utils/documents';
import authenticationService from '../../services/authentication/AuthenticationService';
import documentService from '../../services/document/DocumentService';
import {openOrSaveFile} from '../../utils/http';
import DatetimeFormat from '../datetime/DatetimeFormat';

function DocumentListArchivedView(props) {
  if (props.error) {
    return <Translate value="error.generic"/>;
  }

  const handleDocumentFileOpen = document => () => {
    props.onDownloadDocumentFile();
    authenticationService.authRedirect(documentService.getFileUrl(document.uid))
      .then(authUrl => openOrSaveFile(authUrl, 'pdf'));
  };

  const handleDocumentFileOpenProof = document => () => {
    authenticationService.authRedirect(documentService.getFileProofUrl(document.uid))
      .then(authUrl => openOrSaveFile(authUrl, 'pdf'));
  };

  const groupedDocuments = groupBy(props.documents, element => element.type.code);
  const panels = Object.keys(groupedDocuments)
    .map((key, keyIndex) => {
      const documents = Object.assign([], groupedDocuments[key]).sort(sortRecentFirstWithBestEfforts);
      const constructDocumentLine = (document, documentIndex) => (
        <React.Fragment key={document.uid}>
          {documentIndex !== 0 && <hr/>}
          <div className="row">
            <div className="col-xl-7 col-lg-6 col-sm-5 inline-container ellipsis">
              <span title={document.type.name}>{document.type.name}</span>
            </div>
            <div className="col-xl-1 col-lg-2 col-sm-3 inline-container">
              <span className="no-wrap">
                {Boolean(document.validityStart) && <DatetimeFormat
                  value={document.validityStart}
                  format="shortDate"
                />}
              </span>
            </div>
            <div className="col-xl-1 col-lg-2 col-sm-3 inline-container">
              <span className="no-wrap">
                {Boolean(document.validityEnd) && <DatetimeFormat
                  value={document.validityEnd}
                  format="shortDate"
                />}
              </span>
            </div>
            <div className="col-xl-3 col-lg-2 col-sm-1 inline-container flex-end">
              <span className="inline-container">
                {document.hasProofFile && <button
                  type="button"
                  data-id="download-proof"
                  className="small secondary flex-container no-wrap"
                  title={I18n.t('document.openProof')}
                  onClick={handleDocumentFileOpenProof(document)}
                >
                  <Icon icon="download"/>
                  <span className="d-none d-xl-block"><Translate value="document.openProof"/></span>
                </button>}
                <button
                  type="button"
                  data-id="download"
                  className="small secondary flex-container no-wrap"
                  title={I18n.t('document.open')}
                  onClick={handleDocumentFileOpen(document)}
                >
                  <Icon icon="download"/>
                  <span className="d-none d-lg-block"><Translate value="document.open"/></span>
                </button>
              </span>
            </div>
          </div>
        </React.Fragment>
      );

      return (
        <Accordion key={keyIndex}>
          <AccordionSummary expandIcon={<span className="caret-drop"/>}>
            {documents[0].type.name}
          </AccordionSummary>
          <AccordionDetails>
            <div style={{width: '100%'}}>
              {documents.map(constructDocumentLine)}
            </div>
          </AccordionDetails>
        </Accordion>
      );
    });

  return (
    <div className="mb-3">
      {panels}
    </div>
  );
}

DocumentListArchivedView.defaultProps = {
  documents: []
};

DocumentListArchivedView.propTypes = {
  documents: PropTypes.array,
  error: PropTypes.bool,
  onDownloadDocumentFile: PropTypes.func.isRequired
};

export default DocumentListArchivedView;
